import { Card, useTheme } from "@material-ui/core";
import { Refresh, Warning } from "@material-ui/icons";
import styles from "./HosErrorIndicator.module.css";
import { Button } from "react-admin";

interface Props {
  onRefresh: () => void;
}

export const HosErrorIndicator = ({ onRefresh }: Props) => {
  const theme = useTheme();
  return (
    <div className={styles["error-indicator"]}>
      <Card style={{ background: theme.palette.background.paper }}>
        <div className={styles["card-wrapper"]}>
          <div>
            <Warning style={{ color: theme.palette.warning.main }} />
          </div>
          <div className={styles["card-message"]}>
            <div>We had troubles getting hours of service for this driver.</div>
            <Button label="Try again" onClick={onRefresh}>
              <Refresh />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
